import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import type { SessionBlockExerciseEntity } from "@/modules/sessions/entities/sessionBlockExerciseEntity"
import { getDisplayExerciseCategory } from "@/modules/sessions/sessionDetails/blocks/exerciseBlock/exerciseUtils"
import { RpeTag } from "@/modules/sessions/sessionDetails/components/rpeTag"
import { ChronoIcon } from "@images/svgIcons/chronoIcon"
import { displayTotalTime, getTrainingChronoTitle } from "@modules/chrono/chronoUtils"
import { HURichTextView } from "@modules/ui/components/richText/huRichTextView"
import { formatTextToRichText } from "@modules/ui/components/richText/richTextUtils"

export function FullscreenExerciseDetails({
  exercise,
  className,
  ...props
}: {
  exercise: SessionBlockExerciseEntity
  className?: string
} & React.ComponentProps<"div">) {
  return (
    <div className={cn("flex flex-1 flex-col", className)} {...props}>
      <Text fontStyle="HL" className="mb-4">
        {getDisplayExerciseCategory(exercise.category, exercise.otherCategory)}
      </Text>
      <div className="mb-4 flex items-center">
        {exercise.chrono?.type && (
          <>
            <ChronoIcon color="currentColor" width={25} height={25} className="text-textDefault-body" />
            <div className="mr-4 flex flex-col">
              <Text fontStyle="TS" className="event-content ml-2 text-textDefault-body">
                {getTrainingChronoTitle(exercise.chrono.type)}
              </Text>
              <Text fontStyle="TS" className="event-content ml-2 text-textDefault-body">
                {displayTotalTime(exercise.chrono)}
              </Text>
            </div>
          </>
        )}
        {exercise.rpe && <RpeTag exercise={exercise} />}
      </div>
      <HURichTextView value={formatTextToRichText(exercise.description)} paragrapheFontStyle="TL" />
    </div>
  )
}
